import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY, customPdfReportModal } from './state/reducer';
import { ReportSecuritySearchInputModule } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/report-security-search-modal/report-security-search-input.module';
import { CustomPdfReportSavedAssetOptionsModule } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-saved-asset-options/custom-pdf-report-saved-asset-options.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import { FoldersSharedModule } from 'FoldersApp/features/folders-shared/app.module';
import { SingleSelectDropdownModule } from 'NewAngular/features/components/dropdowns/single-select-dropdown/single-select-dropdown.module';
import { CheckboxGroupModule } from 'NewAngular/features/components/inputs/checkbox-group/checkbox-group.module';
import { LoadingSymbolModule } from 'NewAngular/features/components/loaders/loading-symbol/loading-symbol.module';
import { ConfirmModalModule } from 'NewAngular/features/components/modals/confirm-modal/confirm-modal.module';
import { HelpModalModule } from 'NewAngular/features/components/modals/help-modal/help-modal.module';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
import { PreviewImageModalModule } from 'NewAngular/features/components/modals/preview-image-modal/preview-image-modal.module';
import { TalkingPointTextEditModalModule } from 'NewAngular/features/components/modals/talking-point-text-edit-modal/talking-point-text-edit-modal.module';
import { TextEditModalModule } from 'NewAngular/features/components/modals/text-edit-modal/text-edit-modal.module';
import { OpenItemModalModule } from 'NewAngular/features/components/saved-items/open-item-modal/open-item-modal.module';
import { DisabledModule } from 'NewAngular/features/directives/disabled/disabled.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import { RiskProfilesSharedModule } from 'RiskProfilesApp/features/risk-profiles-shared/risk-profiles-shared.module';
import { AddButtonAutocompleteModule } from 'SearchApp/ts/features/add-button-autocomplete/add-button-autocomplete.module';
import { AutocompleteInPlaceModule } from 'SearchApp/ts/features/autocomplete-in-place/autocomplete-in-place.module';
import { IconSearchAutocompleteModule } from 'SearchApp/ts/features/icon-search-autocomplete/icon-search-autocomplete.module';
import { GetOwnerDisplayNamePipeModule } from 'SharingApp/ts/pipes/get-owner-display-name.module';
import { GetSharingTooltipMessagePipeModule } from 'SharingApp/ts/pipes/get-sharing-tooltip-message.module';
import { IsSharedWithOthersPipeModule } from 'SharingApp/ts/pipes/is-shared-with-others-pipe.module';
import { TalkingPointsEditModalModule } from 'TalkingPointsApp/features/talking-points-edit-modal/talking-points-edit-modal.module';
import { DeleteModalComponent } from 'NewAngular/features/components/delete-modal/delete-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class CustomPdfReportModalModule {
}
CustomPdfReportModalModule.ɵfac = function CustomPdfReportModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CustomPdfReportModalModule)(); };
CustomPdfReportModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: CustomPdfReportModalModule });
CustomPdfReportModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [AddButtonAutocompleteModule,
        AutocompleteInPlaceModule,
        CommonModule,
        ConfirmModalModule,
        CustomPdfReportSavedAssetOptionsModule,
        DeleteModalComponent,
        DisabledModule,
        FeatureNeededModule,
        FoldersSharedModule,
        FormsModule,
        GetOwnerDisplayNamePipeModule,
        GetSharingTooltipMessagePipeModule,
        HelpModalModule,
        IconModule,
        IconSearchAutocompleteModule,
        IsSharedWithOthersPipeModule,
        LoadingSymbolModule,
        ModalBaseModule,
        OpenItemModalModule,
        PreviewImageModalModule,
        ReactiveFormsModule,
        ReportSecuritySearchInputModule,
        RiskProfilesSharedModule,
        SingleSelectDropdownModule,
        StoreModule.forFeature(CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY, customPdfReportModal),
        TalkingPointsEditModalModule,
        TalkingPointTextEditModalModule,
        TextEditModalModule,
        TooltipModule,
        CheckboxGroupModule] });
